import { getFinalReadOnlyMode } from "Areas/Documents/documentDetails/redux/getReadOnlyMode";
import { getInnerObjectsSelectedIds } from "Areas/Documents/documentDetails/redux/selectors";
import graphActionCreators from "Areas/Documents/graph/redux/actionCreators";
import { Permissions, security } from "Common/permissions";
import withPopupMessage from "Components/withPopupMessage";
import filter from "lodash/filter";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import { actionCreators, getActiveDocumentId, getIsExpanded, getNavigationObjects, getObjects, getScripts, getTabScriptsInProgress } from "Areas/Sidebar/DocumentsFloat/redux";
import TabScripts from "./tabScripts";
const SIZES = {
    SCRIPT_EDITOR_PANEL_OFFSET: "-652 0"
};
const getSelectedNodesSource = createSelector((state) => { var _a; return (_a = getNavigationObjects(state)) === null || _a === void 0 ? void 0 : _a.nodesSource; }, (state) => getInnerObjectsSelectedIds(state), (nodesSource, selectedIds) => isEmpty(nodesSource) || isEmpty(selectedIds)
    ? []
    : filter(nodesSource, e => includes(selectedIds, e.NodeId)));
const canRunScripts = security.isAllowed([Permissions.MethodsRun]);
const mapStateToProps = (state) => ({
    isExpanded: getIsExpanded(state),
    activeDocumentId: getActiveDocumentId(state),
    documentObjects: getObjects(state),
    inProgress: getTabScriptsInProgress(state),
    data: getScripts(state),
    selectedNodesSource: getSelectedNodesSource(state),
    canRunScripts,
    readOnlyMode: getFinalReadOnlyMode(state)
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: () => {
        dispatch(actionCreators.getScripts());
        dispatch(actionCreators.getObjects());
    },
    onRunScript: (documentId, scriptId, nodesSource) => {
        dispatch(graphActionCreators.setSaveTriggered(documentId, true));
        dispatch(actionCreators.runScript(documentId, scriptId, nodesSource));
    },
    onSetShowScriptEditorPanel: (show, script, targetSelector) => dispatch(actionCreators.setShowScriptEditorPanel(show, script, targetSelector, SIZES.SCRIPT_EDITOR_PANEL_OFFSET)),
    onDeleteScript: (scriptId) => dispatch(actionCreators.deleteScript(scriptId))
});
export default connect(mapStateToProps, mapDispatchToProps)(withPopupMessage(TabScripts));
